import Runner from '@protonapp/proton-runner-rn0772'
import legacyRunner from '@protonapp/proton-runner'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

export function getRunnerByReactNativeVersion(useNewReactNative) {
  if (useNewReactNative) {
    return withLDConsumer()(Runner)
  } else {
    return withLDConsumer()(legacyRunner)
  }
}
